
define('template!ordersDetailMessagesBodyMessageAttachmentView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (src) { ;
__p += '\n  <img class="image" src="' +
((__t = ( src )) == null ? '' : __t) +
'">\n';
 } ;
__p += '\n\n';
 if (name) { ;
__p += '\n    <div class="name">' +
((__t = ( name )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n\n<div class="buttons-ctn">\n  <div class="buttons">\n      ';
 if (canZoom) { ;
__p += '\n      <div class="zoom-button" title="' +
((__t = ( _.i18n('common.zoom') )) == null ? '' : __t) +
'">\n        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM184 296c-13.3 0-24-10.7-24-24V248H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h40V160c0-13.3 10.7-24 24-24s24 10.7 24 24v40h40c13.3 0 24 10.7 24 24s-10.7 24-24 24H208v24c0 13.3-10.7 24-24 24z"/></svg>\n      </div>\n      ';
 } ;
__p += '\n      <a class="download-button" href="" mimetype="application/octet-stream" title="' +
((__t = ( _.i18n('common.download') )) == null ? '' : __t) +
'" download>\n        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/></svg>\n      </a>\n    </div>\n  </div>\n</div>';

}
return __p
};});

